@if (shouldShowCnpjPopup) {
<div (click)="closePopUp()"
    class="p-3 fixed w-screen h-screen z-50 backdrop-blur-sm bg-black/40 flex justify-center items-center">
    <div (click)="$event.stopPropagation()"
        class="p-4 bg-white border shadow-sm rounded-md w-full sm:w-auto sm:mx-auto sm:mb-0 mb-4 space-y-2">
        <div class="w-full flex items-center">
            <div class="grow">
                <span class="text-sm font-medium">Filtro de CNPJ</span>
            </div>

            <div class="flex-none">
                <svg (click)="closePopUp()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke-width="2" stroke="currentColor" class="size-5 hover:text-blue-500 cursor-pointer">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
            </div>
        </div>

        <div class="space-y-2">
            <div>
                <app-combobox-cnpj [isGlobalCnpj]="isGlobalCnpj"></app-combobox-cnpj>
            </div>

            <div class="p-3 rounded-md bg-gray-100 flex items-center space-x-2 border border-gray-300">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor" class="hidden sm:block size-5 text-gray-500">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                </svg>

                <span class="text-sm text-gray-500 font-medium">
                    Ao selecionar um CNPJ, todas as funcionalidades do sistema utilizarão o CNPJ escolhido.
                </span>
            </div>
        </div>

        <div class="flex flex-col sm:flex-row items-center justify-end sm:space-x-3 space-y-2 sm:space-y-0">
            <button (click)="cleanCnpj()" class="w-full sm:w-auto py-2 px-3 bg-red-500 rounded-md hover:bg-red-700">
                <span class="text-sm text-white font-medium">Limpar filtro</span>
            </button>
            <button (click)="closePopUp()" class="w-full sm:w-auto py-2 px-3 bg-black hover:bg-black/80 rounded-md">
                <span class="text-sm text-white font-medium">Cancelar</span>
            </button>
        </div>
    </div>
</div>
}